module.exports = __webpack_public_path__ + "static/media/gbl-logo.c534d979.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gbl-logo.svg
// module id = 356
// module chunks = 0